import { JSX } from 'preact'
import classnames from 'classnames'
import { SystemButton as ISystemButton } from '@gsc/types'
import { previewProps } from '../../preview'
import { useComponentStyle } from '../Style'

interface Props extends ISystemButton, Omit<JSX.HTMLAttributes<HTMLButtonElement>, 'id' | 'className'> {
  name?: 'close' | 'back' | 'caret'
}

export const SystemButton = ({ id, css, className, name, visible = true, ...props }: Props): JSX.Element => {
  const { classes } = useComponentStyle(name || 'sysbutton', { id, css, className })
  return visible ? (
    <button {...props} className={classnames(classes)} type="button" {...previewProps('sysbutton')} />
  ) : null
}
